export const FOLDER_PARAMS = {
  LIMIT: 'limit',
  PAGE: 'page'
};

export const DEFAULT_FOLDER_PARAMS = {
  LIMIT: 100,
  PAGE: 1
};
